import styles from "./GiftingGuide.module.scss"
import Link from "next/link"
import { useCommonConfirmDialog } from "src/components/hooks/useCommonConfirmDialog"
import { useLocalStorage } from "react-use"
import URLUtils from "src/utils/URLUtils"

const GiftingGuide: React.FC = () => {
  const { confirmDialog } = useCommonConfirmDialog()

  const [showGiftGuide, setShowGiftGuide] = useLocalStorage<boolean>(
    "show_gift_guide",
    true,
  )

  const handleClick = () => {
    confirmDialog(
      `ギフト機能の活用方法を非表示にしますか？`,
      "はい",
      "いいえ",
      () => {
        setShowGiftGuide(false)
      },
    )
  }

  if (!showGiftGuide) return null

  return (
    <div className={styles.guide}>
      <Link href={`${URLUtils.getHelpPage("gift/index.html")}`}>
        <a className={styles.guide_link}>
          <i className={styles.guide_link_icon} />
          ギフト機能の活用方法
        </a>
      </Link>
      <button className={styles.guide_close} onClick={handleClick}>
        <i className={styles.guide_close_icon} aria-label="閉じる" />
      </button>
    </div>
  )
}

export default GiftingGuide
